// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *:before, *:after {
	box-sizing: inherit;
}

html, body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
	height: 100%;
	margin: 0px;
	outline: none;
	overflow-x: hidden;
	padding: 0px;
	width: 100%;
	max-width: 100vw;
}

html {
	box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CAGC,mBAAmB;AACpB;;AAEA;EACE,8JAA8J;EAC9J,mCAAmC;EACnC,kCAAkC;CACnC,YAAY;CACZ,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,gBAAgB;AACjB;;AAEA;CAGC,sBAAsB;AACvB","sourcesContent":["*, *:before, *:after {\n\t-webkit-box-sizing: inherit;\n\t-moz-box-sizing: inherit;\n\tbox-sizing: inherit;\n}\n\nhtml, body {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\theight: 100%;\n\tmargin: 0px;\n\toutline: none;\n\toverflow-x: hidden;\n\tpadding: 0px;\n\twidth: 100%;\n\tmax-width: 100vw;\n}\n\nhtml {\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
